import type { CodableAiJobDefinition } from '@src/service/transport/ai-client/aiJobDefinitionSchema'

import Repository from './base'

export const AI_JOB_DEFINITION_TABLE_NAME = 'aiJobDefinition'
export class AiJobDefinitionRepository extends Repository<CodableAiJobDefinition> {}
